import {NgModule} from '@angular/core'
import {DetailProgramDescSimplificadaComponent} from './detail-program-desc-simplificada/detail-program-desc-simplificada.component'
import {ModalProgramDescSimplificadaComponent} from './modal-program-desc-simplificada/modal-program-desc-simplificada.component'
import {SearchProgramsDescSimplificadaComponent} from './search-programs-desc-simplificada/search-programs-desc-simplificada.component'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {BrowserModule} from '@angular/platform-browser'
import {CommonModule} from '@angular/common'
import {IconsTextModule} from '../icons-text/icons-text.module'
import {DescriptionModule} from '../../description/description.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {PipesModule} from '../../../pipes/pipes.module'
import {FormsModule} from '@angular/forms'
import {InfiniteScrollModule} from 'ngx-infinite-scroll'
import {SharedModule} from '../../shared/shared.module'
@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    IconsTextModule,
    DescriptionModule,
    NgbNavModule,
    PipesModule,
    FormsModule,
    InfiniteScrollModule,
    SharedModule
  ],
  declarations: [
    DetailProgramDescSimplificadaComponent,
    ModalProgramDescSimplificadaComponent,
    SearchProgramsDescSimplificadaComponent
  ],
  exports: [
    DetailProgramDescSimplificadaComponent,
    ModalProgramDescSimplificadaComponent,
    SearchProgramsDescSimplificadaComponent
  ],
  providers: []
})
export class ProgramDescSimplificadaModule {
}
